<template>
	<div class="text-left">
		<div class="portfolio-title">Individual power forecast</div>
		<div class="m-t-xs portfolio-subtitle">
			Production of a individual PV plant
		</div>
		<div class="m-t">
			<div style="width:300px;">
				<multiselect
					v-model="current_location"
					:options="locations"
					:searchable="false"
					:close-on-select="false"
					:show-labels="false"
					label="name"
					placeholder="Select a PV plant"
				></multiselect>
			</div>
		</div>
		<div v-if="current_location">
			<Chart :series="current_location.forecasts" height="300" />
		</div>
	</div>
</template>

<script>
import Chart from "@/components/pages/sub-components/Chart";
import Multiselect from "vue-multiselect";
export default {
	name: "PortfolioSingle",
	components: {
		Chart,
		Multiselect
	},
	props: ["locations"],
	data: function() {
		return {
			current_location: null
		};
	},
	computed: {
		location_list: function() {
			var result = [];
			this.locations.forEach(location => {
				result.push(location.name);
			});
			return result;
		}
	}
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style></style>
